import axios from "axios";
import { toast } from "react-toastify";
export const GetAllLandPayment = (data) => {
  return {
    type: "get_allLandPayment",
    payload: data,
    loader: false,
  };
};
export function getallLandPayment() {
  return (dispatch) => {
    let pgurl = `${
      process.env.REACT_APP_API_URL
    }Vouchers/LandPayment/Populate?ProjectId=${localStorage.getItem(
      "ProjectId"
    )}`;
    if (localStorage.getItem("ProjectId") === null) {
      pgurl = `${process.env.REACT_APP_API_URL}Vouchers/LandPayment/Populate`;
    }
    axios({
      url: pgurl,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllLandPayment(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}

export const GetAllLandTableData = (data) => {
  return {
    type: "get_allLandTableData",
    payload: data,
    loader: false,
  };
};
export function getallLandTable(data) {
  return (dispatch) => {
    let pgurl = `${
      process.env.REACT_APP_API_URL
    }Vouchers/LandPayment/Get?projectid=${localStorage.getItem("ProjectId")}`;
    if (localStorage.getItem("ProjectId") === null) {
      pgurl = `${process.env.REACT_APP_API_URL}Vouchers/LandPayment/Get`;
    }
    axios({
      url: pgurl,
      method: "Post",
      data: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllLandTableData(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
